//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 普通买家form
 * @author Spark
 */
import FormMixins from '~/mixins/form-mixins';
import SubFormMixins from "./form-mixins";
export default {
  name: 'module-putong',
  mixins: [FormMixins, SubFormMixins],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      cards: [{
        img: '洽谈.png',
        title: '业务洽谈',
        description: "\u53D1\u90AE\u4EF6\u81F3\u4E0B\u65B9\u90AE\u7BB1\u6216\u81F4\u7535\u4E1A\u52A1\u7ECF\u7406\u6D3D\u8C08<br/>\n                        \u8054\u7CFB\u4EBA\uFF1A\u7530\u541B\u840D<br/>\n                        \u624B\u673A\uFF1A151 9024 5730<br/>\n                        \u90AE\u7BB1\uFF1Atianjunping@dayaotex.com"
      }, {
        img: '审核.png',
        title: '资质审核',
        description: "\u60A8\u9700\u8981\u63D0\u4F9B\u6709\u6548\u7684\u516C\u53F8\u8D44\u8D28\u8BC1\u660E\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A<br/>\n                        \u4F01\u4E1A\u8425\u4E1A\u6267\u7167<br/>\n                        \u7EC4\u7EC7\u673A\u6784\u4EE3\u7801\u8BC1<br/>\n                        \u7A0E\u52A1\u767B\u8BB0\u8BC1\u3002"
      }, {
        img: '质检.png',
        title: '产品质检',
        description: "\u6211\u4EEC\u4E3A\u60A8\u7684\u4EA7\u54C1\u63D0\u4F9B\u514D\u8D39\u54C1\u68C0\uFF0C\u5408\u4F5C\u4EA7\u54C1\u9700\u7B26\u5408\u4E2D\u6052\u5927\u8000\u8D28\u91CF\u6807\u51C6\u3002"
      }, {
        img: '协议.png',
        title: '协议签署',
        description: "\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u53CC\u65B9\u7B7E\u7F72\u5408\u4F5C\u534F\u8BAE\u60A8\u7684\u4EA7\u54C1\u5373\u53EF\u5728\u4E2D\u6052\u5927\u8000\u7EBF\u4E0A\u7EBF\u4E0B\u6E20\u9053\u8FDB\u884C\u63A8\u5E7F\u9500\u552E\u3002"
      }, {
        img: '监察.png',
        title: '在线监察',
        description: "\u534F\u8BAE\u7B7E\u7F72\u540E\u4F1A\u4E3A\u60A8\u5206\u914D\u4EE3\u9500\u4F9B\u5E94\u5546\u4E0A\u76D1\u67E5\u7CFB\u7EDF\uFF0C\u60A8\u53EF\u968F\u65F6\u638C\u63A7\u6700\u65B0\u5E93\u5B58\u6570\u91CF\uFF0C\u51FA\u5165\u5E93\u6570\u636E\uFF0C\u8BA9\u60A8\u5FEB\u901F\u638C\u63A7\u4EA7\u54C1\u52A8\u6001\uFF0C\u53CA\u65F6\u8C03\u6574\u8425\u9500\u65B9\u6848\u3002"
      }]
    };
  },
  methods: {
    handleUploadBusinessLicense: function handleUploadBusinessLicense(img) {
      this.model.businessLicense = img.fileBigPath;
    },
    handleUploadInvoiceImg: function handleUploadInvoiceImg(img) {
      this.model.invoiceImg = img.fileBigPath;
    }
  }
};